(function() {
  const initSliders = () => {
    // Select all sections with the logo track
    const sections = document.querySelectorAll('.team-logos-section');

    sections.forEach(section => {
      const track = section.querySelector('.logos-track');
      const thumb = section.querySelector('.scroll-bar-thumb');
      
      if (!track || !thumb) return;

      let isDown = false;
      let startX;
      let scrollLeft;

      // Mouse Drag Logic
      track.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
        track.style.scrollBehavior = 'auto';
      });

      track.addEventListener('mouseleave', () => isDown = false);
      track.addEventListener('mouseup', () => {
        isDown = false;
        track.style.scrollBehavior = 'smooth';
      });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 2; 
        track.scrollLeft = scrollLeft - walk;
      });

      // Update Progress Bar
      track.addEventListener('scroll', () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) return;
        const scrollPercentage = (track.scrollLeft / maxScroll) * 100;
        // thumb is 15% width, so we move it within the 85% remaining space
        thumb.style.left = (scrollPercentage * 0.85) + '%';
      });
    });
  };

  // Initialize on load
  if (document.readyState === 'complete') {
    initSliders();
  } else {
    window.addEventListener('load', initSliders);
  }

  // Re-init for Shopify Theme Editor
  document.addEventListener('shopify:section:load', initSliders);
})();